import script from "./category.vue?vue&type=script&setup=true&lang=js"
export * from "./category.vue?vue&type=script&setup=true&lang=js"

import "./category.vue?vue&type=style&index=0&id=5e7b8f32&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7b8f32"]])

export default __exports__